module.exports = __webpack_public_path__ + "static/img/map5.47be19c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/map5.png
// module id = rR4P
// module chunks = 0